import { useEffect, useState } from "react";
import { MdOutlineTimer } from "react-icons/md";
import {
  formatCountdown,
  getCountdownEndMs,
} from "@/utils/packageCardMeta";

export default function PackageCountdown({ item, className = "" }) {
  const endMs = getCountdownEndMs(item);
  const [label, setLabel] = useState(() =>
    endMs ? formatCountdown(endMs - Date.now()) : ""
  );

  useEffect(() => {
    if (!endMs) {
      setLabel("");
      return undefined;
    }

    const tick = () => {
      setLabel(formatCountdown(endMs - Date.now()));
    };

    tick();
    const timer = window.setInterval(tick, 1000);
    return () => window.clearInterval(timer);
  }, [endMs]);

  if (!label) return null;

  return (
    <div className={className}>
      <MdOutlineTimer /> {label}
    </div>
  );
}
